"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isHexString = exports.extractAxiosErrorMessage = void 0;
function extractAxiosErrorMessage(err) {
    var errMsg;
    var error = err;
    var isServerError = !!error.response;
    var serverUnavailable = !!error.request;
    if (isServerError) {
        errMsg = error.response.data.error;
    }
    else if (serverUnavailable) {
        errMsg = 'Server not available';
    }
    else {
        errMsg = error.message;
    }
    return errMsg;
}
exports.extractAxiosErrorMessage = extractAxiosErrorMessage;
function isHexString(string) {
    // TODO: replace with proper library
    return /^([0-9a-fA-F]{2})+$/.test(string);
}
exports.isHexString = isHexString;
